import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-delete-icon',
  imports: [],
  templateUrl: './delete-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './delete-icon.component.scss',
})
export class DeleteIconComponent {}
